import styled from 'styled-components'

import { Color } from '../../theme/color'

export const ProductInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 16px;
  background-color: ${Color.white};
`
